import React, { useContext } from 'react'

import { ArcContext } from 'src/contexts/ArcContext'
import { Spinner } from 'src/components/Spinner'
import { Savings } from 'src/components/Savings'

export function SavingsPage() {
  const { savings } = useContext(ArcContext)

  if (!savings[0]) {
    return (
      <div className="savings-page page">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="savings-page page">
      <Savings saving={savings[0]} />
    </div>
  )
}
